import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  EPCheckbox: {
    width: '30px',
    padding: 0,
  },
  ToolsGrid: {
    display: 'flex',
    padding: `0 ${theme.spacing(1.5)}`,
    border: 'solid 1px #9ab3ce',
    backgroundColor: '#f4f9ff',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  ToolButton: {
    textTransform: 'none',
  },
  ToolText: {
    marginRight: theme.spacing(1.5),
  },
  containerLabel: {
    cursor: 'pointer',
    width: '32px',
    height: '32px',
    marginRight: '0',
  },
  teamChip: {
    margin: '1px',
    backgroundColor: '$BORDERS_LIGHT_GREY',
    '&:hover': {
      backgroundColor: '$LIST_HOVER',
    },
    '& .MuiChip-label': {
      '& a': {
        textDecoration: 'none',
        color: 'initial',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
  eventChip: {
    margin: '1px',
    borderRadius: '5px',
    backgroundColor: '$BORDERS_LIGHT_GREY',
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: '#LIST_HOVER',
    },
  },
}));
